import { RpcDialogData, RpcDialogResult } from './rpc-dialog-model';

/**
 * Rpc dialog sever side handler interface.
 */
export interface RpcDialogHandler {
    handler(data: RpcDialogData): Promise<RpcDialogResult>;
}
